import React from 'react';
import {LauncherComponentBase} from '../../base-components/launcher-component-base';
import {observer} from 'mobx-react';
import ReactJson, {InteractionProps} from 'react-json-view'
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import {Check} from '@sparkware/app-utils';
import {LOCAL_STORAGE_OVERRIDES_KEYS} from '../../../services/orbit-configs-storage/configs-storage.service';

@observer
export class OrbitConfigOverridesValueEditorComponent extends LauncherComponentBase<{}> {
    private _getJson() {
        let json = this.services.configsStorage.getValue(LOCAL_STORAGE_OVERRIDES_KEYS.ORBIT_CONFIG_OVERRIDES) || '{}';
        return JSON.parse(json);
    }

    private _addEditDeleteHandler = (eventData: InteractionProps) => {
        if(Check.isEmpty(eventData.updated_src)) {
            this.services.configsStorage.updateValue(LOCAL_STORAGE_OVERRIDES_KEYS.ORBIT_CONFIG_OVERRIDES, undefined);
        } else {
            this.services.configsStorage.updateValue(LOCAL_STORAGE_OVERRIDES_KEYS.ORBIT_CONFIG_OVERRIDES, JSON.stringify(eventData.updated_src));
        }
        return true;
    };

    render() {
        return (
            <div style={{marginLeft: '10px'}}>
                <Typography variant="subtitle2" display="block" gutterBottom>
                    Orbit Config Overrides
                </Typography>

                <ReactJson src={this._getJson()}
                           name={false}
                           displayDataTypes={false}
                           displayObjectSize={false}
                           defaultValue={''}
                           onAdd={this._addEditDeleteHandler}
                           onEdit={this._addEditDeleteHandler}
                           onDelete={this._addEditDeleteHandler} />
                <div style={{marginTop: '5px'}}>
                    <Divider/>
                </div>
            </div>);
    }
}